/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils, lodash } from '@ba-ui-toolkit/utils';
import { Checkbox as CarbonCheckbox } from 'carbon';
import TruncatedText from '@ba-ui-toolkit/truncatedtext';

import './Checkbox.scss';

const { sanitize, BaPropTypes } = propsUtils;

const { uniqueId } = lodash;

export default class Checkbox extends Component {
	static propTypes = {
		id: PropTypes.string,
		label: PropTypes.node,
		title: PropTypes.string,
		tabIndex: PropTypes.number,

		align: BaPropTypes.deprecated('is ignored and not applicable to carbon checkbox'),
		checked: PropTypes.bool,
		indeterminate: PropTypes.bool,

		disabled: PropTypes.bool,
		readOnly: BaPropTypes.deprecated('is ignored and not applicable to carbon checkbox'),
		hover: BaPropTypes.deprecated('is ignored and not applicable to carbon checkbox'),
		active: BaPropTypes.deprecated('is ignored and not applicable to carbon checkbox'),
		visual: PropTypes.bool,

		onClick: PropTypes.func,
		onChange: PropTypes.func,
		'aria-labelledby': PropTypes.string,
		className: PropTypes.string,
		style: PropTypes.object,
		labelExtraOptions: BaPropTypes.deprecated(
			'is ignored and not applicable to carbon checkbox'
		),
	};

	static defaultProps = {
		align: 'left',
		checked: false,
		className: '',
		style: {},
	};

	// Internet Explorer only fires the onchange event when the checkbox loses the focus (onblur).
	// For components like checkbox, onClick is preferred.
	onClick = e => {
		const { onClick } = this.props;

		onClick && onClick(e);
	};

	onChange = value => {
		const { onChange } = this.props;

		onChange && onChange(value);
	};

	focus() {
		this._inputNode && this._inputNode.focus();
	}

	_ref = node => {
		this._inputNode = node;
	};

	_id = uniqueId('__checkbox_');

	render() {
		const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

		const {
			className,
			id,
			label,
			title,
			tabIndex,
			checked,
			indeterminate,
			disabled,
			visual,
			style,
			...others
		} = this.props;

		const classNames = cx(className, {
			visual, // visual prop is used to ignore pointer events like clicks in scss
		});

		const htmlId = id || this._id;
		const labelElement = label && <TruncatedText value={label} />;

		return (
			<CarbonCheckbox
				wrapperClassName={classNames}
				id={htmlId}
				indeterminate={indeterminate}
				checked={checked}
				labelText={labelElement}
				title={title}
				disabled={disabled}
				onTouchStart={iOS ? this.onClick : undefined}
				onClick={!iOS ? this.onClick : undefined}
				onChange={this.onChange}
				tabIndex={visual ? -1 : tabIndex}
				style={style}
				ref={this._ref}
				{...sanitize(others, Checkbox)}
			/>
		);
	}
}
